import { render, staticRenderFns } from "./ModuleIcon.vue?vue&type=template&id=1e0aa223&scoped=true"
import script from "./ModuleIcon.vue?vue&type=script&lang=ts"
export * from "./ModuleIcon.vue?vue&type=script&lang=ts"
import style0 from "./ModuleIcon.vue?vue&type=style&index=0&id=1e0aa223&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0aa223",
  null
  
)

export default component.exports